import { Group, Loader, Stack, Text } from '@mantine/core';
import { MediaBubble } from '../bubbles';
import { BubbleBody, type WaRendererProps } from './primitives';

/**
 * Image / video / audio / voice / document.
 *
 * Distinguishes "the mirror worker hasn't fetched this yet" (`pending` — a
 * placeholder that upgrades itself once the worker lands and realtime
 * refreshes the row) from "there is nothing to fetch" (`unavailable`). Before
 * this split both looked like a permanent failure.
 */
export function MediaMessage({ view, incoming }: WaRendererProps) {
  const media = view.media;
  if (!media) return <BubbleBody>{view.body ?? view.fallbackLabel}</BubbleBody>;
  const dim = incoming ? 'dimmed' : 'rgba(255,255,255,0.85)';
  return (
    <Stack gap={4}>
      {/* Audio and voice have no visual of their own — an unlabelled player
          reads as "something happened here". Name the kind so every media
          bubble is self-describing. */}
      {media.kind === 'audio' && (
        <Text size="xs" c={dim} fw={500}>
          {media.label}
        </Text>
      )}
      {media.status === 'pending' ? (
        <Group gap={6} wrap="nowrap">
          <Loader size="xs" />
          <Text size="xs" c={dim}>
            Downloading {media.kind}…
          </Text>
        </Group>
      ) : (
        <MediaBubble
          kind={media.kind}
          url={media.url}
          alt={media.label}
          fileName={media.fileName}
        />
      )}
      {view.caption && <BubbleBody>{view.caption}</BubbleBody>}
    </Stack>
  );
}
